export default __webpack_public_path__ + "static/media/library-menu-icon-white.27f903c5.svg";